/* ZOMKI: seleccion independiente de tallas, añade ambas variantes a Shopify */
(function () {
  'use strict';
  document.addEventListener('submit', async function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action.includes('/cart/add')) return;
    const top = form.querySelector('[name="items[0][id]"]');
    const bottom = form.querySelector('[name="items[1][id]"]');
    if (!top || !bottom) return;
    event.preventDefault();
    const ids = [Number(top.value), Number(bottom.value)];
    if (ids.some(v => !Number.isSafeInteger(v) || v <= 0)) {
      form.reportValidity();
      return;
    }
    const submitter = form.querySelector('[type="submit"]');
    const initialLabel = submitter ? submitter.textContent : '';
    if (submitter) {
      submitter.disabled = true;
      submitter.textContent = 'Añadiendo las dos prendas…';
    }
    let error = form.querySelector('.zomki-cart-feedback');
    if (!error) {
      error = document.createElement('p');
      error.className = 'zomki-cart-feedback';
      error.setAttribute('role','alert');
      error.style.cssText = 'color:#b00035;margin:10px 0 0;font-size:14px;';
      form.appendChild(error);
    }
    error.textContent = '';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(id => ({ id, quantity: 1 })) })
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.description || result.message || 'No se han podido añadir las dos prendas.');
      }
      window.location.assign(root + 'cart');
    } catch (e) {
      error.textContent = e instanceof Error ? e.message : 'No hemos podido completar la operación. Vuelve a intentarlo.';
      if (submitter) {
        submitter.disabled = false;
        submitter.textContent = initialLabel;
      }
    }
  }, true);
})();
